import { render } from "./IconInvestedRoundedType4.vue?vue&type=template&id=bd51609e&ts=true"
import script from "./IconInvestedRoundedType4.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__